import { useNavigate } from "react-router-dom";
import i18next from "../../i18n/i18n";
import styles from "./Layout.module.css";
import wap from "../../assets/wap.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../Store";

interface HeaderTitleButtonProps {
    onNavigateChat?: () => void;
}

const HeaderTitleButton = ({ onNavigateChat }: HeaderTitleButtonProps) => {
    const navigate = useNavigate();

    const fileUploadOrDeleteAPITriggerActive = useSelector((store: RootState) => store.questionInput.fileUploadOrDeleteAPITriggerActive);
    const isAnswerLoading = useSelector((store: RootState) => store.chatComponent.isAnswerLoading);
    const isDisabled = Boolean(fileUploadOrDeleteAPITriggerActive?.triggerActive || isAnswerLoading);

    const handleClick = () => {
        onNavigateChat?.();
        if (location.pathname !== "/assistant/chat" || (location.pathname === "/assistant/chat" && location.search !== "")) {
            navigate("/assistant/chat");
        }
    };

    return (
        <div style={{ justifyContent: "space-around" }}>
            <button
                type="button"
                className={styles.headerTitleContainer}
                disabled={isDisabled}
                onClick={handleClick}
                aria-label={i18next.t("layout.wap")}
                style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    background: "none",
                    border: "none"
                }}
            >
                <img src={wap} alt={i18next.t("layout.wap")} style={{ marginRight: "20px" }} />
                <h2 className={styles.headerTitle}>{i18next.t("layout.headerTitleOne")}</h2>
                <h5 className={styles.headerTitle} style={{ marginTop: "0px", marginLeft: "7px" }}>
                    {i18next.t("layout.headerTitleTwo")}
                </h5>
            </button>
        </div>
    );
};

export default HeaderTitleButton;
